import { render, staticRenderFns } from "./SetToSameDay.vue?vue&type=template&id=2fd85150&scoped=true&"
import script from "./SetToSameDay.vue?vue&type=script&lang=js&"
export * from "./SetToSameDay.vue?vue&type=script&lang=js&"
import style0 from "./SetToSameDay.vue?vue&type=style&index=0&id=2fd85150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd85150",
  null
  
)

export default component.exports